import type { RouteLocationNormalizedLoadedGeneric } from 'vue-router'

import type { UserLoadingStrategy } from '../types'

import { findRouteOrParentMatchingPredicate } from './routes'

/**
 * Determines the userLoadingStrategy value based on route meta and app config.
 * Route meta takes precedence over app config.
 */
export function getUserLoadingStrategy(
  route: RouteLocationNormalizedLoadedGeneric,
  appUserLoadingStrategy: UserLoadingStrategy,
): UserLoadingStrategy {
  const matchedRouteWithUserLoadingStrategy =
    findRouteOrParentMatchingPredicate(
      route,
      (routeDefinition) =>
        !!(routeDefinition.meta && routeDefinition.meta.userLoadingStrategy),
    )

  return (
    (matchedRouteWithUserLoadingStrategy?.meta?.userLoadingStrategy as
      | UserLoadingStrategy
      | undefined) || appUserLoadingStrategy
  )
}
